// extracted by mini-css-extract-plugin
export default {"melodyVideo":"sJ-z","isFullWidth":"tJ-z","landingPageVideo":"uJ-z","play":"vJ-z","iframeVideo":"wJ-z","playHidden":"xJ-z","fullwidth":"yJ-z"};